// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1286":"7a89905e","8905":"7a89905e","9632":"c80dd170"}[chunkId] + ".chunk.css";
};